import script from "./DeepSeek.vue?vue&type=script&setup=true&lang=js"
export * from "./DeepSeek.vue?vue&type=script&setup=true&lang=js"

import "./DeepSeek.vue?vue&type=style&index=0&id=52adab3f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52adab3f"]])

export default __exports__